import { render, staticRenderFns } from "./DispatchTracker.vue?vue&type=template&id=6178f560&scoped=true"
import script from "./DispatchTracker.vue?vue&type=script&lang=js"
export * from "./DispatchTracker.vue?vue&type=script&lang=js"
import style0 from "./DispatchTracker.vue?vue&type=style&index=0&id=6178f560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178f560",
  null
  
)

export default component.exports